<template>
  <img width="53px" src="/image/logo_vce.png" alt="" />
</template>
